
import {mapState} from 'vuex';

export default {
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      menuSidebar: state => state.menuSidebar,
    }),
  },
};
